import { SaleTranslate } from './saleTranslate.model';

const saleTranslatePTBR: SaleTranslate = {
  section: {
    title: 'Vendas',
    registerButton: 'Registrar venda',
    cancelButton: 'Cancelar',
    duplicateButton: 'Duplicar',
    emptyState: 'Nenhuma venda registrada',
    cancelConfirmation: {
      title: 'Cancelar venda',
      description:
        'Tem certeza que deseja cancelar esta venda? Esta ação não pode ser desfeita.',
      confirm: 'Sim, cancelar',
    },
  },
  paymentMethod: {
    PIX: 'PIX',
    CASH: 'Dinheiro',
    CREDIT_CARD: 'Cartão de Crédito',
    DEBIT_CARD: 'Cartão de Débito',
    BANK_TRANSFER: 'Transferência',
    BOLETO: 'Boleto',
    OTHER: 'Outro',
  },
  installmentStatus: {
    PENDING: 'Pendente',
    PAID: 'Pago',
    OVERDUE: 'Atrasado',
  },
  installments: {
    toggle: 'Parcelamento ({{count}}x)',
    row: {
      number: 'Parcela {{current}}/{{total}}',
      markPaid: 'Marcar como paga',
      receipt: 'Recibo',
    },
    receipt: {
      error: 'Não foi possível baixar o recibo',
    },
  },
  registerModal: {
    title: 'Registrar venda',
    sections: {
      services: 'Serviços',
      packages: 'Pacotes',
    },
    fields: {
      servicesPlaceholder: 'Selecione serviços',
      packagesPlaceholder: 'Selecione pacotes',
      servicesSearchPlaceholder: 'Buscar serviço',
      servicesNoResults: 'Nenhum serviço encontrado',
      packagesSearchPlaceholder: 'Buscar pacote',
      packagesNoResults: 'Nenhum pacote encontrado',
      quantityPlaceholder: 'Qtd',
      totalPrice: 'Total (R$)',
      paymentMethod: 'Forma de pagamento',
      installmentsCount: 'Número de parcelas',
      firstDueDate: 'Vencimento da 1ª parcela',
      soldAt: 'Data da venda',
      notes: 'Observações',
    },
    errors: {
      itemsMin: 'Selecione ao menos um serviço ou pacote',
      totalPositive: 'Total deve ser maior que zero',
      totalInvalidType: 'Total deve ser um número',
      installmentsInvalidType: 'Número de parcelas deve ser um número',
      installmentsMin: 'Mínimo 1 parcela',
      installmentsMax: 'Máximo 24 parcelas',
      paymentMethodRequired: 'Forma de pagamento é obrigatória',
      firstDueDateRequired:
        'Vencimento da 1ª parcela é obrigatório para parcelamento',
      firstDueDateInvalid: 'Data inválida',
      soldAtRequired: 'Data da venda é obrigatória',
      soldAtInvalid: 'Data da venda inválida',
      installmentsSumMismatch:
        'A soma das parcelas deve ser igual ao valor total',
      installmentsDateInvalid: 'Uma das datas de vencimento é inválida',
    },
    installments: {
      customizeLabel: 'Personalizar parcelas',
      amount: 'Valor',
      dueDate: 'Vencimento',
      sum: 'Total das parcelas',
    },
    actions: {
      cancel: 'Cancelar',
      register: 'Registrar venda',
    },
    aria: {
      removeService: 'Remover serviço',
      removePackage: 'Remover pacote',
    },
  },
  metrics: {
    tabLabel: 'Vendas',
    kpi: {
      revenue: {
        label: 'Faturamento do mês',
        subtext: '{{delta}} vs período anterior',
      },
      ticket: {
        label: 'Ticket médio',
      },
      count: {
        label: 'Total de vendas',
      },
      overdue: {
        label: 'Inadimplência',
        zero: 'Tudo em dia',
        tooltip:
          'Total de parcelas vencidas no período, independente dos filtros aplicados',
        infoAria: 'Sobre o cálculo de inadimplência',
      },
      pending: {
        label: 'A receber (mês)',
      },
      received: {
        label: 'Recebido (mês)',
      },
    },
    drawer: {
      title: 'Filtros',
      paymentMethod: 'Forma de pagamento',
      package: 'Pacote',
      service: 'Serviço',
      year: 'Ano',
      apply: 'Aplicar filtros',
      clear: 'Limpar filtros',
    },
    slider: {
      aria: 'Navegar meses',
      previous: 'Mês anterior',
      next: 'Próximo mês',
    },
    filtersAria: 'Abrir filtros',
  },
};

export default saleTranslatePTBR;
